module.exports = __webpack_public_path__ + "static/hordelogin-6cfb8827bc9d415e3c4df0ef4db0843e.gif";